import React from "react";
import { Button } from "evergreen-ui";
import "./submitbutton.css";

const SubmitButton = ({ loading, ApplyFunction, text }) => {
  return (
    <Button
      className="submitQuoteBtn"
      isLoading={loading}
      onClick={() => {
        ApplyFunction();
      }}
      size="medium"
    >
      {text}
    </Button>
  );
};

export default SubmitButton;
